<template>
    <view class="container ignore-none" :class="{ 'animated-button': isChecked, active: isActive }" @click="handleClick">
        <slot></slot>
    </view>
</template>

<script setup>
    import { nextTick, ref } from 'vue';
    import { useDebounceClick } from '@/hooks/debounceClick.js';
    import { playAudio } from '@/utils/public';
    const isActive = ref(false);
    const isChecked = ref(true);
    const props = defineProps({
        animated: {
            type: Boolean,
            default: true
        }
    });
    const handleClick = useDebounceClick(() => {
        isChecked.value = true;
        if (props.animated) {
            isActive.value = !isActive.value;
            setTimeout(() => {
                isActive.value = false;
                isChecked.value = false;
            }, 100); // 动画持续时间
        }
        nextTick(() => {
            playAudio();
        });
    });
</script>

<style scoped>
    .animated-button.active {
        animation: pulse 0.2s ease-in-out;
        /* transform: scale(0.96); */
    }
</style>
